import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ConsumerPortalApiService } from './consumer-portal-api.service';
import { FeatureMapUserAccount } from '../admin/interfaces/user-accout.interface';
import { Searchable } from '../models/searchable.model';

@Injectable({
    providedIn: 'root'
})
export class UserAccountService {
    private readonly consumerPortalApi = inject(ConsumerPortalApiService);

    getUserAssignFeatures(customerId: string): Observable<FeatureMapUserAccount> {
        return this.consumerPortalApi.get<Searchable & FeatureMapUserAccount>(`user-accounts/roles/${customerId}`).pipe(
            map(data => {
                const response = data as unknown as FeatureMapUserAccount;
                return response;
            })
        );
    }
}
